import { Component } from '@angular/core';

@Component({
  selector: 'alert-warning-message',
  templateUrl: './alert-warning-message.component.html',
  styleUrls: ['./alert-warning-message.component.css']
})

export class AlertWarningMessageComponent {
}
